<div class="sk-marquee-container">
    @for (number of [0, 1, 2, 3, 4]; track number) {
        <div class="sk-marquee-event sk-p-12 sk-b-rad8">
            <div class="sk-marquee-market">
                <div class="sk-marquee-team">
                    <div class="sk-circle"></div>
                    <div class="sk-marquee-players">
                        <div class="sk-marquee-player1 sk-h-12 sk-b-rad8"></div>
                        <div class="sk-marquee-player2 sk-h-12 sk-b-rad8"></div>
                    </div>
                </div>
                <div class="sk-odds">
                    <div class="sk-odd1 sk-b-rad4"></div>
                    <div class="sk-odd2"></div>
                </div>
            </div>
        </div>
    }
</div>
